<template>
  <v-row class="desposite-dashboadpage">
    <v-col xs="8" md="8">
      <ul class="breadcrumbs-list">
        <a @click="backButton">
          <li>Investment</li>
        </a>
        <li>&nbsp;>&nbsp;Real Estate</li>
      </ul>
      <div class="head-text">
        <h1>Real Estate Dashboard</h1>
      </div>
      <RealStateTab />
    </v-col>
    <v-col xs="4" md="4">
      <div class="right-sidetop-box">
        <div class="select-box">
          <v-card>
            <v-select
              :items="member_list"
              :v-model="member_name"
              item-value="id"
              item-text="name"
              chips
              label="All Users"
              @change="refershMutualFundDashboard"
            ></v-select>
          </v-card>
        </div>
        <div class="add-btn" v-if="allow_user_activity == 'yes'">
          <v-btn class="orange-btn btn" @click="subCategory">ADD NEW</v-btn>
        </div>
      </div>
      <v-row>
        <v-col cols="12" sm="12">
          <v-card class="right-sidebox">
            <div class="right-sidetop-box">
              <!--  <div class="select-box">
                <v-card>
                  <v-select :items="mfc_list" :v-model="mfc_id" item-value="id" item-text="name" chips label="--AMC--" @change="mfcData"></v-select>
                </v-card>
              </div> -->
              <!--  <div class="select-box">
                <v-card>
                  <v-select :items="scheme_type_list" :v-model="scheme_type_id" item-value="id" item-text="name" chips  @change="schemeTypeData" label="Select Filter"></v-select>
                </v-card>
              </div> -->
            </div>
            <div v-if="show_graph_block">
              <v-skeleton-loader
                :loading="loading"
                type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"
              >
                <div cols="12" class="total-deposit-box">
                  <span>
                    Total Real Estate Valuation on
                    {{ currentDate | moment("DD MMM, Y") }}
                  </span>
                  <p><span> &#8377;</span> {{ graphTotal.toLocaleString() }}</p>
                </div>
                <div id="chart">
                  <!-- <apexchart type="donut" :options="chartOptions" :series="series"></apexchart> -->
                  <apexchart
                    type="pie"
                    :options="chartOptions"
                    :series="series"
                    graphData
                  ></apexchart>
                  <ul class="chart-listbox">
                    <li
                      class="first-li"
                      v-for="balance_detail in real_state_details"
                      :key="balance_detail.id"
                    >
                      <div class="chart-listbox-dotbox">
                        <span
                          class="dots"
                          :style="{
                            'background-color': balance_detail.web_color,
                          }"
                        ></span>
                        <p>{{ balance_detail.acoount_type }}</p>
                      </div>
                      <span>
                        <span class="rupee"> &#8377;</span>
                        {{ balance_detail.balance }}</span
                      >
                    </li>
                  </ul>
                </div>
                <div class="button-box">
                  <v-btn class="btn download-btn" @click="downloadReport">
                    <v-img
                      max-height="20"
                      max-width="16"
                      :src="require('@/assets/images/download-icon.png')"
                    ></v-img
                    >DOWNLOAD</v-btn
                  >
                  <!-- <v-btn class="btn share-btn">
                    <v-img max-height="20" max-width="18" :src="require('@/assets/images/share-icon.png')"></v-img>SHARE</v-btn> -->
                  <v-menu
                    bottom
                    origin="center center"
                    transition="scale-transition"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="btn share-btn" v-bind="attrs" v-on="on">
                        <v-img
                          max-height="20"
                          max-width="18"
                          :src="require('@/assets/images/share-icon.png')"
                        >
                        </v-img>
                        SHARE
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item>
                        <v-list-item-title>
                          <WhatsApp
                            :url="share_report_url"
                            scale="1.6"
                          ></WhatsApp>
                        </v-list-item-title>
                        <v-list-item-title>
                          <Telegram
                            :url="share_report_url"
                            scale="1.6"
                          ></Telegram>
                        </v-list-item-title>
                        <v-list-item-title>
                          <Email :url="share_report_url" scale="1.6"></Email>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </div>
              </v-skeleton-loader>
            </div>
            <div v-else="!show_graph_block" style="margin-bottom: 42px">
              <v-list-item>
                <div class="user-detailbox">
                  <v-list-item-content>
                    <div class="text-h5 mb-1">No data found in graph.</div>
                  </v-list-item-content>
                </div>
              </v-list-item>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<script>
import RealStateTab from "./RealStateTab";
import {
  POST_API,
  GET_API,
  UPDATE_USER_DETAILS,
  GET_REAL_ESTATE_FORM_DETAIL,
} from "../../../store/actions.type";
import ApiService from "../../../api/api.service";
import { isEmpty } from "lodash";
import { WhatsApp, Telegram, Email } from "vue-socialmedia-share";
import axios from "axios";
import JwtService from "../.././common/jwt.service";
export default {
  components: {
    RealStateTab,
    WhatsApp,
    Telegram,
    Email,
  },
  data: () => ({
    member_items: [],
    mfc_list: [],
    scheme_type_list: [],
    member_name: "",
    three_dots: process.env.VUE_APP_ROOT_ICONS_URL + "three_dots.png",
    edit_pic: process.env.VUE_APP_ROOT_ICONS_URL + "edit.png",
    delete_pic: process.env.VUE_APP_ROOT_ICONS_URL + "delete.png",
    currentDate: new Date().setDate(new Date().getDate()),
    series: [],
    chartOptions: {
      dataLabels: {
        formatter(val) {
          return [val.toFixed() + "%"];
        },
      },
      labels: [],
      fill: {
        colors: [],
      },
      chart: {
        type: "pie",
        edrawOnParentResize: true,
      },
      responsive: [
        {
          breakpoint: undefined,
          options: {},
        },
      ],
      legend: {
        show: false,
      },
    },
    real_state_details: "",
    saving_balance: "",
    reccuring_balance: "",
    deposite_balance: "",
    sukanaya_balance: "",
    tabName: "",
    graphTotal: "",
    seriesTotal: [],
    member_list: [],
    show_graph_block: true,
    graphDefault: "",
    mfc_id: "",
    mfc_list: [],
    scheme_type_list: [],
    scheme_type_id: "",
    member_id: "",
    loading: false,
    graphDefault: "default",
    share_report_url: "",
    allow_user_activity: localStorage.getItem("allow_user_activity"),
  }),

  mounted() {
     this.refershMutualFundDashboard('');
    Fire.$on("updateRealStateData", () => {
      this.graphData();
      this.shareLink();
    });

    if (!isEmpty(this.$store.getters.getRealEstateFormDetail)) {
      this.graphData();
      this.shareLink();
    }
  },
  methods: {
    subCategory() {
      this.$router.push({
        name: "SubCategory",
        params: { current_category_id: 3 },
      });
    },
    backButton() {
      this.$router.push({ name: "Investment" });
    },
    graphData() {
      this.colors = [];
      this.labels = [];
      this.series = [];
      this.mfc_list = [];
      this.scheme_type_list = [];
      this.real_state_details = [];
      this.seriesTotal = [];
      this.graphTotal = 0;

      this.member_list =
        this.$store.getters.getRealEstateFormDetail.member_list;

      this.$store.getters.getRealEstateFormDetail.balaces_details.balances.forEach(
        (garpColorData) => {
          this.series.push(parseInt(garpColorData.balance));
          this.seriesTotal.push(garpColorData.balance);
          this.chartOptions.labels.push(garpColorData.acoount_type);
          this.chartOptions.fill.colors.push(garpColorData.web_color);
        }
      );

      this.real_state_details =
        this.$store.getters.getRealEstateFormDetail.balaces_details.balances;
      this.graphTotal = this.seriesTotal.reduce((a, b) => a + b, 0);

      if (this.graphTotal == 0) {
        this.show_graph_block = false;
      } else {
        this.show_graph_block = true;
      }
    },
    refershMutualFundDashboard(event) {
      this.$loading(true);
      let cognito_idp = atob(localStorage.getItem("cognito_idp"));
      let user_name = this.$store.getters.getUserDetails.user_name;
      // this.singleUpdateAuthUser('commitSingleData', {key:'selected_value', value:event.toString()});
      let userData = [{ key: "selected_value", value: event.toString() }];
      this.$store.dispatch(UPDATE_USER_DETAILS, userData);
      
      let selected_value = this.$store.getters.getUserDetails.selected_value;
      selected_value = selected_value ? selected_value : "";
      this.$store
        .dispatch(GET_REAL_ESTATE_FORM_DETAIL, {
          data: {
            aws_cognito_id: cognito_idp,
            member_id: event,
            user_name: user_name,
            mfc_id: this.mfc_id,
            scheme_type_id: this.scheme_type_id,
            mutual_filter: this.scheme_type_id,
          },
          api: "get-real-estate-form-detail",
        })
        .then(() => {
          this.colors = [];
          this.labels = [];
          this.series = [];
          this.mfc_list = [];
          this.scheme_type_list = [];
          this.real_state_details = [];
          this.seriesTotal = [];
          this.graphTotal = 0;

          this.member_list =
            this.$store.getters.getRealEstateFormDetail.member_list;
           
            
          this.$store.getters.getRealEstateFormDetail.balaces_details.balances.forEach(
            (garpColorData) => {
              this.series.push(parseInt(garpColorData.balance));
              this.seriesTotal.push(garpColorData.balance);
              this.chartOptions.labels.push(garpColorData.acoount_type);
              this.chartOptions.fill.colors.push(garpColorData.web_color);
              
            }
             
          );

          this.real_state_details =
            this.$store.getters.getRealEstateFormDetail.balaces_details.balances;
          this.graphTotal = this.seriesTotal.reduce((a, b) => a + b, 0);

          Fire.$emit("updateRealStateData");
          if (this.graphTotal == 0) {
            this.show_graph_block = false;
          } else {
            this.show_graph_block = true;
          }
          this.$loading(false);
        })
        .catch(() => {
          this.$loading(false);
        });
      
    },
    downloadReport() {
      window.open(
        this.$store.getters.getRealEstateFormDetail.pdf_url,
        "_blank"
      );
    },
    shareLink() {
      this.share_report_url =
        this.$store.getters.getRealEstateFormDetail.pdf_url;
      return this.share_report_url;
    },
  },
};
</script>
